export default "__VITE_ASSET__C$3jQyAH__"